module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_8.5ea520b6.png";